<template>
    <div id="app" class="is-clipped lb-full-height">
        <vue-progress-bar />
        <transition :name="transitionName" mode="out-in">
            <component :is="layout">
                <router-view></router-view>
                <!--transition
          name="custom-animation"
          enter-active-class="animated slideInDown"
          leave-active-class="animated slideOutUp"
          mode="out-in"
        -->
                <app-modal-login v-if="showLoginForm" />
                <!--/transition-->
            </component>
        </transition>
        <p
            style="position: fixed; bottom: 0; right: 0; opacity: 0.5"
            class="tag is-primary is-light"
        >
            {{ versionHash }}
        </p>
    </div>
</template>

<script>
import { logout } from '@/services/API';
import Default from '@/layouts/Default';
import Project from '@/layouts/Project';
import Community from '@/layouts/Community';
import AppModalLogin from '@/components/AppModalLogin';
import { version } from '../package.json';
export default {
    components: {
        Default,
        Project,
        Community,
        AppModalLogin,
    },
    data() {
        return {
            transitionName: '',
        };
    },
    computed: {
        personalData() {
            return this.$store.getters.personalData;
        },
        showLoginForm() {
            return this.$store.getters.showLoginForm;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        layout() {
            return this.$route.meta.layout || 'Default';
        },
        isDev() {
            return process.env.NODE_ENV !== 'production';
        },
        versionHash() {
            return version + '.' + process.env.VUE_APP_GIT_HASH;
        },
    },
    watch: {
        $route(to, from) {
            const toDepth = to.path.split('/').length;
            const fromDepth = from.path.split('/').length;
            this.transitionName =
                toDepth < fromDepth ? 'slide-right' : 'slide-left';
        },
        personalData(profile) {
            this.$ga.set('userId', profile._id);
            if (!profile.name || !profile.name.length) {
                console.warn('[REDIRECT] to profile because name is missing');
                //this.$router.push("profile");
            }
        },
    },
    mounted() {
        if (this.isLoggedIn) {
            this.$store.dispatch('fetchProfile');
        }
    },
    methods: {
        logout() {
            this.$router.push('/');
            logout();
        },
    },
};
</script>

<style>
html,
body {
    height: 100%;
    overflow: hidden;
}
@import '~animate.css';
@import '~vue-toastification/dist/index.css';

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
.slide-left-enter,
.slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(30px, 0);
    transform: translate(30px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-30px, 0);
    transform: translate(-30px, 0);
}

.lb-project-card {
    transition: all 0.3s;
}

.lb-project-list {
    opacity: 0;
    /*transform: scale(2);*/
}
.navbar-item img {
    max-height: unset !important;
}
.Vue-Toastification__container {
    z-index: 9999999;
}
</style>

<style lang="scss">
@import './style/tailwind.css';
@import 'src/assets/sass/labygram-style';
@import '~vue-plyr/dist/vue-plyr.css';
@import '~bulma-tooltip';
@import '~@creativebulma/bulma-badge';
@import '~@creativebulma/bulma-collapsible';
@import '~bulma-steps-component/bulma-steps.sass';

#app {
    //font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
    height: 100%;
    overflow-y: auto;
}
.pac-container {
    // google maps autocomplete
    z-index: 9999999 !important;
}
.pac-card {
    // google maps autocomplete
    z-index: 9999999 !important;
}

.plyr__video-wrapper {
    height: unset;
}
</style>

<style>
.plyr--youtube.plyr--paused.plyr__poster-enabled:not(.plyr--stopped)
    > .plyr__video-wrapper
    > .plyr__poster {
    display: none;
}
</style>
